/* DON'T EDIT THIS FILE: edit original and run build again */ import { Section, SectionCollection } from "./section.tsx";

export const createDefaultSectionValidator =
  (section: Section<any>, sectionCol: SectionCollection<any>) => () =>
    section.isOptional() ? null : section.getError(sectionCol);
